/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import UseSvg from "common/vue/components/UseSvg.react.vue";
import "./ArtworkShippingProgress.scss";

export default function ArtworkShippingProgress({ ...restProps }) {
  const currencySign = "$";

  return (
    <div
      {...restProps}
      className="artwork-shipping-progress js-pdp-shipping-progress-bar-wrapper scope-cb614c47"
    >
      <div className="artwork-shipping-progress__bar-tile artwork-shipping-progress__bar-tile--complete js-pdp-shipping-progress-bar-complete scope-cb614c47 hidden">
        <div className="artwork-shipping-progress__bar-icon-wrap scope-cb614c47">
          <UseSvg
            className="artwork-shipping-progress__shipping-progress-bar-icon-complete scope-cb614c47"
            icon="free-shipping-truck"
            width="60"
            height="30"
            data-testid="artwork-shipping-progress-shipping-progress-bar-icon-complete"
          />
        </div>
        <span className="artwork-shipping-progress__bar-text-complete scope-cb614c47">
          Free Shipping!
        </span>
      </div>
      <div className="artwork-shipping-progress__bar-tile artwork-shipping-progress__bar-tile--shortfall js-pdp-shipping-progress-bar-shortfall scope-cb614c47 hidden">
        <div className="artwork-shipping-progress__shipping-progress-bar-icon-wrap scope-cb614c47">
          <UseSvg
            className="artwork-shipping-progress__bar-icon-delivery scope-cb614c47"
            icon="fast-delivery"
            width="34"
            height="34"
            data-testid="artwork-shipping-progress-bar-icon-delivery"
          />
        </div>
        <span className="artwork-shipping-progress__bar-text scope-cb614c47">
          <span className="artwork-shipping-progress__bar-total js-pdp-shipping-progress-bar-amount scope-cb614c47">
            {}
          </span>{" "}
          from free shipping{" "}
        </span>
        <div
          className="progress-bar artwork-shipping-progress__shipping-progress-bar js-pdp-shipping-progress-bar scope-cb614c47"
          data-currency-sign={currencySign}
        >
          <span className="scope-cb614c47">{currencySign}0</span>
          <div className="progress-bar__line-wrap scope-cb614c47">
            <div className="progress-bar__line js-pdp-shipping-progress-bar-line scope-cb614c47" />
          </div>
          <span className="js-pdp-shipping-progress-bar-threshold scope-cb614c47" />
        </div>
      </div>
    </div>
  );
}
